import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import {
    SprayProductUnits,
    SprayProductPerUnitType
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { AppState } from 'services/types';
import { makeSelectRate } from './selectors';

export interface OwnProps {
    units: SprayProductUnits;
    unitTypeId: UnitTypeId;
    perUnitType: SprayProductPerUnitType;
}

interface ConnectedProps {
    rate: string;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductRateListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { rate } = this.props;

        return <ListItem description="Rate" value={rate} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rate: makeSelectRate()
});

export default connect(mapStateToProps)(SummaryProductRateListItemComponent);
